import { render, staticRenderFns } from "./index.vue?vue&type=template&id=442a8f44&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=442a8f44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a8f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442a8f44')) {
      api.createRecord('442a8f44', component.options)
    } else {
      api.reload('442a8f44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=442a8f44&scoped=true", function () {
      api.rerender('442a8f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditorForm/index.vue"
export default component.exports